import { Title } from '../types';

// Dummy data to simulate API responses
export const DUMMY_TRENDING: Title[] = [
    {
        id: 1,
        external_id: "tt1234567",
        title_name: "Stranger Things",
        release_year: 2016,
        poster_url: "https://via.placeholder.com/150",
        overview: "A group of kids encounter supernatural forces in their small town.",
        vote_count: 150
    },
    {
        id: 2,
        external_id: "tt2345678",
        title_name: "The Mandalorian",
        release_year: 2019,
        poster_url: "https://via.placeholder.com/150",
        overview: "A lone bounty hunter travels the outer reaches of the galaxy.",
        vote_count: 120
    },
];

export const DUMMY_TOP_REQUESTS: Title[] = [
    {
        id: 3,
        external_id: "tt3456789",
        title_name: "Wednesday",
        release_year: 2022,
        poster_url: "https://via.placeholder.com/150",
        overview: "Wednesday Addams attends Nevermore Academy.",
        vote_count: 200
    },
    {
        id: 4,
        external_id: "tt4567890",
        title_name: "The Last of Us",
        release_year: 2023,
        poster_url: "https://via.placeholder.com/150",
        overview: "A smuggler escorts a teenage girl across a post-apocalyptic America.",
        vote_count: 180
    },
];

export const getTrendingTitles = async (): Promise<Title[]> => {
    // Simulating API call
    return new Promise((resolve) => {
        setTimeout(() => resolve(DUMMY_TRENDING), 500);
    });
};

export const getTopRequests = async (): Promise<Title[]> => {
    // Simulating API call
    return new Promise((resolve) => {
        setTimeout(() => resolve(DUMMY_TOP_REQUESTS), 500);
    });
};

export const searchTitles = async (query: string): Promise<Title[]> => {
    // Simulating search
    return new Promise((resolve) => {
        const filtered = [...DUMMY_TRENDING, ...DUMMY_TOP_REQUESTS]
            .filter(title => title.title_name.toLowerCase().includes(query.toLowerCase()));
        setTimeout(() => resolve(filtered), 300);
    });
};